import { constants } from './constants';

/**
 * Feed del blog desde el Headless CMS del core.
 *
 * POR QUÉ ESTO Y NO `public/blog/mixed`: esas rutas están comentadas en el core
 * (apps/api/public_urls.py) desde que el blog se migró al Headless CMS, y
 * responden 404. El bloque de blog de la home se quedaba con el spinner girando
 * para siempre.
 *
 * Es EXACTAMENTE la misma fuente y el mismo mapeo que usa el proyecto Next.js
 * que sirve /blog (nextjs-main-web/src/app/api/blog/mixed/route.ts), así que lo
 * que enseña la home y lo que se abre al pulsar es el mismo artículo.
 *
 * Idioma: el CMS filtra por `lang`, y con `es` incluye además los artículos
 * antiguos sin idioma. Hoy NO hay artículos en inglés (count 0 medido), así que
 * si el idioma pedido viene vacío se cae a español antes que enseñar un hueco.
 */

const mapResults = (results) =>
  (Array.isArray(results) ? results : []).map((item) => ({
    UUID: item.UUID,
    link: item.slug,
    kind: (item.payload && item.payload.category) || '',
    title: item.title,
    author: (item.payload && item.payload.author) || '',
    image: (item.payload && item.payload.image_url) || '',
    created_at: item.created_at || '',
  }));

const fetchPage = async (lang, pageSize) => {
  const url = `${constants.getHeadlessCMS}?token=${constants.blogCmsProv}`
    + `&page=1&page_size=${pageSize}&lang=${encodeURIComponent(lang)}&format=json`;
  const res = await fetch(url, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error(`headless-cms ${res.status}`);
  const data = await res.json();
  return mapResults(data && data.results);
};

export const fetchBlogFeed = async ({ lang = 'es', pageSize = 3 } = {}) => {
  const clean = /^[a-z]{2}$/.test(String(lang).toLowerCase()) ? String(lang).toLowerCase() : 'es';
  const items = await fetchPage(clean, pageSize);
  if (items.length || clean === 'es') return items;
  return fetchPage('es', pageSize);
};
